<div>
<form [formGroup]="baseFormGroup" #f="ngForm" class="">
  <div class="form-group row">
    <div class="col-md-12">
      <yt-dropdown-picklist 
      [ModelName]="'radnomesto'" 
      [GetName]="'getRoot'" 
      [ModelProperty]="'Naziv'" 
      [OrderBy]="'Naziv'"
      [AllowAddNew]='true' 
      formControlName="RadnoMestoID" 
      [Label]="'RADNOMESTO.TATA.SINGULAR'" 
      [Type]="'treeview'">
      </yt-dropdown-picklist>

      <div class="form-error" *ngIf="submitted && fc.RadnoMestoID.invalid">
        <span *ngFor="let validation of errorMessages.RadnoMestoID">
          <span class="error-message" *ngIf="fc.RadnoMestoID.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
        </span>
      </div>
    </div>
  </div>

  <div class="form-group row">
    <div class="col-md-10">
      <yt-input [Type]="'number'" [Label]="'SISTRADNIHMESTA.BROJIZVRSILACA.SINGULAR'" name="numberbroj_izvrsilaca"
        formControlName="broj_izvrsilaca" [ngClass]="{'is-invalid': submitted && fc.broj_izvrsilaca.invalid}">
      </yt-input>
      <div class="form-error" *ngIf="submitted && fc.broj_izvrsilaca.invalid">
        <span *ngFor="let validation of errorMessages.broj_izvrsilaca">
          <span class="error-message" *ngIf="fc.broj_izvrsilaca.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
        </span>
      </div>
    </div>
  </div>
</form>
</div>